'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.log = log;
function log(target, name, descriptor) {
    var _old = descriptor.value;
    descriptor.value = function () {
        // console.log('> LOG >>> [' + name + '] with arguments ==> ', arguments);
        return _old.apply(this, arguments);
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/log.js
// module id = 764
// module chunks = 0